import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookie_consent');
    if (!accepted) setShow(true);
  }, []);

  const accept = () => { localStorage.setItem('cookie_consent', 'accepted'); setShow(false); };
  const decline = () => { localStorage.setItem('cookie_consent', 'declined'); setShow(false); };

  if (!show) return null;

  return (
    <div style={{
      position:'fixed', bottom:0, left:0, right:0, zIndex:9999,
      background:'#fff', borderTop:'2px solid var(--ink-100)',
      padding:'16px 24px', display:'flex', gap:16, alignItems:'center',
      flexWrap:'wrap', boxShadow:'0 -4px 24px rgba(0,0,0,0.08)'
    }}>
      <div style={{flex:1,minWidth:200}}>
        <p style={{margin:0,fontSize:'0.875rem',color:'var(--ink-600)'}}>
          We use cookies to improve your experience. By using BudgetTutor you agree to our{' '}
          <a href="/privacy" style={{color:'var(--green-700)',fontWeight:600}}>Privacy Policy</a> and{' '}
          <a href="/terms" style={{color:'var(--green-700)',fontWeight:600}}>Terms of Service</a>.
        </p>
      </div>
      <div style={{display:'flex',gap:8,flexShrink:0}}>
        <button onClick={decline} className="btn btn-ghost btn-sm">Decline</button>
        <button onClick={accept} className="btn btn-primary btn-sm">Accept cookies</button>
      </div>
    </div>
  );
}
